import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { withClarityTheme } from '@verifime/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { XpmConnectionIllustration } from '../XpmConnectionIllustration';

type XpmIntegrationSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const XpmIntegrationSuccessModalComponent = ({
  isOpen,
  onClose,
}: Readonly<XpmIntegrationSuccessModalProps>) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          maxWidth: '500px',
          width: '100%',
        },
      }}
    >
      <DialogContent
        sx={(theme) => ({
          px: theme.semantic.spacing['2lg'],
          py: theme.semantic.spacing.base,
        })}
      >
        <Stack
          alignItems="center"
          sx={(theme) => ({
            gap: theme.semantic.spacing['2lg'],
          })}
        >
          {/* Connection Status Section */}
          <Stack
            alignItems="center"
            sx={(theme) => ({
              gap: theme.semantic.spacing.xs,
            })}
          >
            {/* Active Status Chip */}
            <Chip
              icon={<FiberManualRecordIcon sx={{ fontSize: 12 }} />}
              label="Active"
              size="small"
              sx={(theme) => ({
                bgcolor: theme.palette.status.success.fill,
                color: theme.palette.status.success.text,
                fontWeight: theme.semantic.fontWeight.regular,
                px: theme.semantic.spacing.xs,
                py: theme.semantic.spacing['3xs'],
                '& .MuiChip-icon': {
                  color: theme.palette.status.success.icon,
                },
              })}
            />

            {/* Integration Illustration */}
            <XpmConnectionIllustration variant="connected" />
          </Stack>

          {/* Content Wrapper */}
          <Stack
            alignItems="center"
            sx={(theme) => ({
              gap: theme.semantic.spacing.sm,
              width: '100%',
            })}
          >
            {/* Success Message */}
            <Typography variant="h4" textAlign="center">
              Integration to Xero Practice Manager was successful
            </Typography>

            <Typography variant="body1" textAlign="center">
              Now you can request and receive real-time verifications of your
              customers from XPM
            </Typography>
          </Stack>

          {/* Close Button */}
          <Button variant="outlined" onClick={onClose} fullWidth>
            CLOSE MODAL
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export const XpmIntegrationSuccessModal = withClarityTheme(
  XpmIntegrationSuccessModalComponent,
);
